// Tipos de ausencia de este sistema y las horas de PTO por dia que cada uno pone por default.
// Lo usan el alta manual (Absences) y las solicitudes aprobadas (AbsenceRequests).
export const PAID_TYPES = [
  'PTO- Sick', 'PTO- Vacation', 'PTO- Personal Day', 'PTO- Half Day',
  'Maternity / Paternity', 'Bereavement', 'Holiday', 'Injury',
];
export const UNPAID_TYPES = ['Time Off Without Pay', 'Sick', 'Half Day'];

export const AUTO_PTO = {
  'PTO- Sick': 8, 'PTO- Vacation': 8, 'PTO- Personal Day': 8, 'PTO- Half Day': 4,
  'Maternity / Paternity': 8, 'Bereavement': 8, 'Holiday': 8, 'Injury': 8,
  'Time Off Without Pay': 0, 'Sick': 0, 'Half Day': 0,
};

// Tipo de la app de ausencias -> tipo de aqui. Los nombres de alla son texto libre, asi que se
// compara por palabra clave; lo que no se reconozca se deja vacio y se escoge a mano.
export function mapRequestType(name) {
  const s = String(name || '').toLowerCase();
  if (!s) return '';
  if (s.includes('without pay') || s.includes('unpaid') || s.includes('sin goce')) return 'Time Off Without Pay';
  if (s.includes('half')) return 'PTO- Half Day';
  if (s.includes('vacation') || s.includes('vacacion')) return 'PTO- Vacation';
  if (s.includes('sick') || s.includes('enferm')) return 'PTO- Sick';
  if (s.includes('personal')) return 'PTO- Personal Day';
  if (s.includes('matern') || s.includes('patern')) return 'Maternity / Paternity';
  if (s.includes('bereave') || s.includes('luto') || s.includes('duelo')) return 'Bereavement';
  if (s.includes('injur')) return 'Injury';
  return '';
}
